import React, { useEffect, useState } from 'react';
import { Box, Button, IconButton, Modal, Typography, useMediaQuery, useTheme } from '@mui/material';
import Products from '../Components/Products';
import MyCart from '../Components/MyCart';
import Loader from '../Components/Loader';
import Toastify from '../Components/Toastify';
import Styles from '../Config/Styles';
import { useDispatch, useSelector } from 'react-redux';
import { getdraftOrders } from '../Redux/Mycart/action';
import ArrowForwardIosOutlinedIcon from '@mui/icons-material/ArrowForwardIosOutlined';
import CloseIcon from '@mui/icons-material/Close';
import { useSwipeable } from 'react-swipeable';
import { getSwipped } from '../Redux/Categories/action';

const Buymaterial = () => {
  const { orders } = useSelector((state) => state?.CartData) || [];
  const theme = useTheme()
  const dispatch = useDispatch()
  // State for loading spinner
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const isMobile = useMediaQuery(theme.breakpoints?.down("lg"));

  useEffect(() => {
    dispatch(getdraftOrders({ session: sessionStorage.getItem("session") }))
  }, [open])
  useEffect(() => {

  }, [orders])

  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false)
  };
  const handlers = useSwipeable({
    onSwipedLeft: () => {
    }
  });


  return (
    <>
      <Box sx={Styles.buymaterial.box}>
        {/* Loader Component */}
        <Loader open={loading} />

        <Box sx={Styles.buymaterial.box1}>
          {/* Products Section */}
          <Products setLoading={setLoading} />

          {/* My Cart Section */}
          <Box
            sx={Styles.buymaterial.cartbox}
          >
            <MyCart cart={true} orders={orders} />
          </Box>
        </Box>


        {/* Toast Notifications */}
        <Toastify />
      </Box>

      {/* Handle cart on mobile and tab */}
      {isMobile && !open && orders?.length >= 1 && <Button sx={Styles.viewcart.btn} onClick={handleOpen}>
        <Typography sx={Styles.viewcart.typo}>{orders?.length}</Typography>
        <Typography>View Product Request</Typography>
        <Typography><ArrowForwardIosOutlinedIcon /></Typography>
      </Button>}
      <Modal className="box" open={open} onClose={handleClose} sx={Styles.viewcart.modal}>
        <>
          <IconButton onClick={handleClose} sx={Styles.viewcart.icon}>
            <CloseIcon sx={Styles.productsdetails.closebtn} />
          </IconButton>
          <MyCart orders={orders} cart={true} />
        </>
      </Modal>
    </>
  );
};

export default Buymaterial;
